import { createSelector } from '@ngrx/store';
import { getDragonflyState } from '../reducers';
import { getScreenSize } from 'src/app/shared/selectors/literals.selectors';

export const getListsState = createSelector(getDragonflyState, (state) => state?.lists);

export const getTargets = createSelector(getListsState, (state) => state?.targets);

export const getPanelExpansion = createSelector(getListsState, (state) => state?.panelExpanded);

export const getName = createSelector(getListsState, (state) => state?.name);

export const getDescription = createSelector(getListsState, (state) => state?.description);

export const getTarget = createSelector(getListsState, (state) => state?.target);

export const getTargetsValuesWithLiterals = createSelector(
  getScreenSize,
  getTargets,
  (literals, targets) =>
    targets?.map((target) => ({
      id: target,
      description: literals[`liquid.campaign.selectiontarget.${target.toLowerCase()}`] || target,
    })) || [],
);
